<template>
  <div>
    <!-- 订单支付 -->
    <baseBreadcrumb :page="$t('message.paymentOfAnOrder')" :menu="$t('message.orderForm')" />
    <orderMain status="订单支付" />
  </div>
</template>
<script>
import orderMain from "@/components/order/baseTable/index.vue";
export default {
  components: {
    orderMain,
  },
  data() {
    return {};
  },
};
</script>
<style lang='scss' scoped></style>